module.exports = __webpack_public_path__ + "img/points.dc1b8a29.svg";